import { render, staticRenderFns } from "./carfigIndex.vue?vue&type=template&id=572e4926&"
import script from "./carfigIndex.vue?vue&type=script&lang=js&"
export * from "./carfigIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports